import api from './api';

export const getSupervisorPerformance = (supervisorId, { startDate, endDate, month } = {}) =>
  api.get(`/performance/supervisor/${supervisorId}`, {
    params: startDate || endDate ? { start_date: startDate, end_date: endDate } : month ? { month } : {},
  });

export const getDepartmentPerformance = (departmentId, { startDate, endDate, month } = {}) =>
  api.get(`/performance/department/${departmentId}`, {
    params: startDate || endDate ? { start_date: startDate, end_date: endDate } : month ? { month } : {},
  });

export const getProjectPerformance = (projectId, { startDate, endDate, includeSubProjects, includeExpenses } = {}) =>
  api.get(`/performance/project/${projectId}`, {
    params: {
      start_date: startDate,
      end_date: endDate,
      ...(includeSubProjects ? { include_sub_projects: true } : {}),
      ...(includeExpenses ? { include_expenses: true } : {}),
    },
  });

export const getEmployeePerformance = (employeeId, { startDate, endDate } = {}) =>
  api.get(`/performance/employee/${employeeId}`, {
    params: { start_date: startDate, end_date: endDate },
  });

// "Top 10" leaderboards - one per filter mode (supervisor/department/project/
// employee), so the Performance page has something to show the moment a
// mode is picked, before any one entity is selected from the dropdown.
const getTopN = (kind) => ({ startDate, endDate, month, limit, includeExpenses } = {}) =>
  api.get(`/performance/top/${kind}`, {
    params: {
      ...(startDate || endDate ? { start_date: startDate, end_date: endDate } : month ? { month } : {}),
      ...(limit ? { limit } : {}),
      // Only meaningful for 'projects' - ignored server-side for the other
      // three kinds, harmless to always pass through.
      ...(includeExpenses ? { include_expenses: true } : {}),
    },
  });

export const getTopSupervisors = getTopN('supervisors');
export const getTopDepartments = getTopN('departments');
export const getTopProjects = getTopN('projects');
export const getTopEmployees = getTopN('employees');
